<template>
  <div
    class="table-search-container"
  >
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;"
      @search="value => $emit('onSearch', value)"
    />
    <a-select
      show-search
      placeholder="选择类型"
      style="width: 142px; margin:0 23px;"
      @change="value => $emit('onChange', value)"
    >
      <a-select-option
        v-for="item in selectData"
        :key="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-button
      v-if="addbtnIsShow"
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      {{ addText }}
    </a-button>
  </div>
</template>
<script>
export default {
  props: ['selectData', 'addText', 'addbtnIsShow'],
  data() {
    return {};
  },
  methods: {
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-select-selection {
    border-radius: 15px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
